import store from '../../store'

const showIdUpdateModal = customer => {
	return (customer.residency_status === 'Resident Ghanaian' && customer.identification_document_type !== 'National ID') || customer.is_id_expired
}

export default function app(mutation) {
	const { type, payload } = mutation

	switch (type) {
		case 'setLocalStorage':
			const user = JSON.parse(payload.user)
			if (user.type === 'customer') {
				store.dispatch('setShowIdUpdateModal', showIdUpdateModal(user.customer))
			}
			break
		case 'setShowIdUpdateModal':
			localStorage.setItem('showIdUpdateModal', payload)
			break
		case 'setActiveAccount':
			localStorage.setItem('activeAccount', JSON.stringify(payload))
			break
		default:
			break
	}
}
